export enum OpportunitySectors {
    RESIDENTIAL = 'Residential',
    RETAIL = 'Retail',
    HOTEL_RESTAURANT = 'Hotel & Restaurant',
    CORPORATE = 'Corporate',
    MUSEUM = 'Museum art & exhibitions',
    MIXED = 'Mixed use'
}
